module.exports = __webpack_public_path__ + "static/media/Jupiter.0e94094d.png";